<template>
  <mHeader name="会员注册" />
  <mSmallLayout>
    <Form @submit="onSubmit">
      <CellGroup inset>
        <Field
          v-model="formData.account"
          placeholder="请输入登录账号"
          :rules="rules.account"
        />
        <Field
          v-model="formData.password"
          type="password"
          placeholder="请输入登录密码"
          :rules="rules.password"
        />
        <Field
          v-model="formData.checkPassword"
          type="password"
          placeholder="请再一次确认登录密码"
          :rules="rules.checkPassword"
        />
        <Cell>
          <Button type="primary" block native-type="submit">注册</Button>
        </Cell>
        <Cell>
          已有账号？
          <router-link to="/user/register">立即登录</router-link>
        </Cell>
      </CellGroup>
    </Form>
  </mSmallLayout>
</template>
<script>
import { reactive } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { Form, Field, Button, Cell, CellGroup } from 'vant'

import { registerUser, getRsaKey } from '@/api/user'
import { rsaEn } from '@/utils/tools'
import UI from '@/utils/ui'

import 'vant/es/field/style'
import 'vant/es/button/style'
import 'vant/es/cell/style'
import 'vant/es/cell-group/style'

export default {
  components: { Form, Field, Button, Cell, CellGroup },
  setup () {
    const store = useStore()
    const router = useRouter()
    const formData = reactive({
      account: '',
      password: '',
      checkPassword: ''
    })

    const rules = {
      account: [
        { required: true, message: '请输入登录账号' },
        { validator: val => val.length >= 5 && val.length <= 20, message: '登录账号长度在 5 到 20 个字符' }
      ],
      password: [
        { required: true, message: '请输入登录密码' },
        { validator: val => val.length >= 6, message: '密码长度必须是6位以上哦！' }
      ],
      checkPassword: [
        { required: true, message: '请输入确认登录密码' },
        { validator: val => val.length >= 6, message: '密码长度必须是6位以上哦！' },
        { validator: val => val === formData.password, message: '两次输入密码不一致!' }
      ]
    }

    const onSubmit = async () => {
      UI.toast.loading()
      const { data: key } = await getRsaKey()
      const { account, password } = formData
      const enPw = rsaEn(password, key)

      const { data: token } = await registerUser({ account, password: enPw })
      UI.toast.success('注册成功！')
      await store.dispatch('user/setToken', token)
      router.push('/user')
    }
    return {
      formData,
      onSubmit,
      rules
    }
  }
}
</script>
